/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")




export interface API47853Req {
  
  /** 项目id */
  projectNo?: string;
  /** 用户编号列表 ,String */
  userNoList?: any[];
  /** 部门id */
  orgId?: string;
  /** 项目角色（10：项目负责人；20：项目助理；30：项目成员） */
  roleType?: number;
  /** 加入项目时间 */
  joinDate?: any;
};



export type API47853Res = {};


// 47853 添加项目成员

export interface IUsePostAPI47853Return {
  /** 添加项目成员: 接口请求状态 */
  isAPI47853Loading: boolean;
  /** 添加项目成员: 接口请求返回数据 */
  dataAPI47853: API47853Res;
  /**  添加项目成员: 接口数据请求方法 */
  fetchAPI47853Data:  (inputs: API47853Req, config?: YWRequestConfig) => Promise<API47853Res>;
  /** 添加项目成员: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI47853 = ():IUsePostAPI47853Return => {
  let isMount = true;
  const [isAPI47853Loading, setIsAPI47853Loading] = useState(false);
  const [dataAPI47853, setDataAPI47853] = useState<API47853Res>({} as API47853Res);
  const requestUrl = `${basePath}/corp-admin/project/team/member/add`;

  const fetchAPI47853Data = async (inputs: API47853Req, config?: YWRequestConfig): Promise<API47853Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API47853Req>) || {}) as API47853Req;
    
  
    if ( isMount ) {
      setIsAPI47853Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API47853Res>(`${basePath}/corp-admin/project/team/member/add`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI47853(res || {} as API47853Res);
        setIsAPI47853Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI47853Loading(false);
      }
      return false as unknown as API47853Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI47853Loading,
    dataAPI47853,
    fetchAPI47853Data,
    requestUrl,
  }
}

